// Recovered compiled webpack factory 60543. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      fillCacheWithNewSubTreeData: function () {
        return l;
      },
      fillCacheWithNewSubTreeDataButOnlyLoading: function () {
        return u;
      },
    }));
  let n = r(94201),
    a = r(30637),
    o = r(69190),
    i = r(65360);
  function s(e, t, r, s, l, u) {
    let { segmentPath: c, seedData: f, tree: d, head: p } = s,
      h = t,
      _ = r;
    for (let t = 0; t < c.length; t += 2) {
      let r = c[t],
        s = c[t + 1],
        m = t === c.length - 2,
        g = (0, o.createRouterCacheKey)(s),
        y = _.parallelRoutes.get(r);
      if (!y) continue;
      let v = h.parallelRoutes.get(r);
      (v && v !== y) || ((v = new Map(y)), h.parallelRoutes.set(r, v));
      let b = y.get(g),
        E = v.get(g);
      if (m) {
        if (f && (!E || !E.lazyData || E === b)) {
          let t = f[0],
            r = f[1],
            o = f[3];
          ((E = {
            lazyData: null,
            rsc: u || t !== i.PAGE_SEGMENT_KEY ? r : null,
            prefetchRsc: null,
            head: null,
            prefetchHead: null,
            loading: o,
            parallelRoutes: u && b ? new Map(b.parallelRoutes) : new Map(),
            navigatedAt: e,
          }),
            b && u && (0, n.invalidateCacheByRouterState)(E, b, d),
            u && (0, a.fillLazyItemsTillLeafWithHead)(e, E, b, d, f, p, l),
            v.set(g, E));
        }
        continue;
      }
      E &&
        b &&
        (E === b &&
          ((E = {
            lazyData: E.lazyData,
            rsc: E.rsc,
            prefetchRsc: E.prefetchRsc,
            head: E.head,
            prefetchHead: E.prefetchHead,
            parallelRoutes: new Map(E.parallelRoutes),
            loading: E.loading,
          }),
          v.set(g, E)),
        (h = E),
        (_ = b));
    }
  }
  function l(e, t, r, n, a) {
    s(e, t, r, n, a, !0);
  }
  function u(e, t, r, n, a) {
    s(e, t, r, n, a, !1);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
